import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Breadcrumb({ breadcrumb }) {
  const location = useLocation();
  const currentPath = location.pathname;

  // ──────────────────────────────────────────────
  // OA Workflow routes → route-based breadcrumb
  // ──────────────────────────────────────────────
  if (currentPath.includes('/oa-workflow')) {
    const crumbs = [
      { label: 'Home', to: '/dashboard' },
      { label: 'Collaboration Space', to: '/collaboration-space' },
      { label: 'OA Shell', to: '/collaboration-space/oa-workflow' }
    ];

    if (currentPath.includes('/users')) {
      crumbs.push({ label: 'User Management' });
    } else if (currentPath.includes('/batches')) {
      crumbs.push({ label: 'Validation Result' });
    } else if (currentPath.includes('/intake')) {
      crumbs.push({ label: 'Upload Intake' });
    } else if (currentPath.match(/\/tasks\/\d+/)) {
      crumbs.push({ label: 'Task Detail' });
    }

    return (
      <div className="breadcrumb" style={{ marginTop: 16 }}>
        {crumbs.map((crumb, idx) => (
          <span key={idx}>
            {idx > 0 && <span>&nbsp;/&nbsp;</span>}
            {crumb.to && idx < crumbs.length - 1 ? (
              <Link style={{ textDecoration: 'none', color: 'rgb(56 58 135)' }} to={crumb.to}>
                {crumb.label}
              </Link>
            ) : (
              <span style={{ color: '#666' }}>{crumb.label}</span>
            )}
          </span>
        ))}
      </div>
    );
  }

  // ──────────────────────────────────────────────
  // Original folder-based breadcrumb logic
  // ──────────────────────────────────────────────
  const generatePathForBreadcrumb = (breadcrumb, index, folderId) => {
    const pathItems = breadcrumb.slice(0, index + 1);
    if (currentPath.includes('/shared/hash')) {
      const pathList = currentPath.split('/');
      return `/collaboration-space/shared/hash/${pathList[4]}` + pathItems.map((item) => item.folderId).join('/');
    } else if (currentPath.includes("shared") && !currentPath.includes("hash")) {
      return `/collaboration-space/shared/` + pathItems.map((item) => item.folderId).join('/');
    } else {
      if (currentPath.includes('workspace')) {
        return `/collaboration-space/workspace/` + pathItems.map((item) => item.folderId).join('/');
      } else {
        return `/collaboration-space/my-files/` + pathItems.map((item) => item.folderId).join('/');
      }
    }
  };

  return (
    <div className="breadcrumb" style={{ marginTop: 16 }}>
      {breadcrumb && breadcrumb.map((item, index) => (
        <span key={item.folderId}>
          {index > 0 && <span>&nbsp;/&nbsp;</span>}
          <Link style={{ textDecoration: 'none', color: 'rgb(56 58 135)' }} to={generatePathForBreadcrumb(breadcrumb, index, item.folderId)}>{item.folderName}</Link>
        </span>
      ))}
    </div>
  );
}

export default Breadcrumb;
